import query from '@/components/query/query-constructor';
import Vue from 'vue';
import i18n from '@/i18n/index';

export const pushURL = (ctx: Vue, cb?: any) => {
  if (ctx.$route.name !== 'app.index')
    return;

  const filters = ctx.$store.state.dashboard.query;
  const data = query.get(filters);

  ctx.$router.replace({
    name: 'app.index',
    params: {
      data: data
    }
  }, cb, cb);
};


export const sortByPickerData = ()=>{
  return [
    {
      pickerValue: 'reports-profit',
      userValue:'profit',
      //@ts-ignore
      title: i18n.vm.t('Profit')
    },
    {
      pickerValue: 'reports-revenue',
      userValue:'revenue',
      //@ts-ignore
      title: i18n.vm.t('Revenue')
    },
    {
      pickerValue: 'reports-cost',
      userValue:'cost',
      //@ts-ignore
      title: i18n.vm.t('Cost')
    },

    {
      pickerValue: 'reports-visits',
      userValue:'visits',
      //@ts-ignore
      title: i18n.vm.t('Visits')
    },
    {
      pickerValue: 'reports-clicks',
      userValue:'clicks',
      //@ts-ignore
      title: i18n.vm.t('Clicks')
    },
    {
      pickerValue: 'reports-conversionconfirm',
      userValue:'conversions',
      //@ts-ignore
      title: i18n.vm.t('Conversions')
    },
  ]
};
